/**
 * GENERAL JS
 * /assets/general.js
 */
whenAvailable('$', function() {
 $(function () {
    // GENERIC ACCORDION
    $('.generic-accordion-link:not(.disabled)').click(function() {
        if ( $(this).hasClass('active') ) {
            $('.generic-accordion-body').stop().slideUp();
            $('.generic-accordion-link').removeClass('active');
            $('.generic-accordion-link').children('span').removeClass('rotate180');
        } else {
            $('.generic-accordion-body').stop().slideUp();
            $('.generic-accordion-link').removeClass('active');
            $('.generic-accordion-link').children('span').removeClass('rotate180');
            $(this).addClass('active');
            $(this).children('span').addClass('rotate180');
            $(this).siblings('.generic-accordion-body').stop().slideDown();
        }
    });

    // ANIMATED SCROLL
    $('.generic-toc a, a.animate-scroll').click(function() {
        window.scrollTo({top: ($(this?.hash)?.offset()?.top-$('.nav-main')?.height()-20), behavior: 'smooth'});
    });
    $('.scroll').click(function() {
        var positionOffset = 0;
        if ( $('.nav-main').hasClass('sticky-top') ) {
            positionOffset = $('.nav-main').height();
        } else if ( $('#nav_features').length > 0 ) {
            positionOffset = $('#nav_features').height();
        } else if ( $('.catalog-nav').length > 0 ) {
            positionOffset = $('.catalog-nav').height();
        }

        const offsetTop = $(this.hash).offset()?.top;
        if (!offsetTop) return;
        window.scrollTo({top: Math.round(offsetTop - positionOffset), behavior: 'smooth'});
    });
    $('.scrollTop').click(function(e) { e.preventDefault(); window.scrollTo({top: 0, behavior: 'smooth'}); });

    // PARTNERS AND OTHER HASH
    var win_hash = window.location.hash.split('&')[0].split('?')[0];
    win_hash = win_hash.replace('%','');

    // IF PAGE HAS HASH POS, ONLOAD GOTO IT
    if (win_hash != '#') {
        if (win_hash !== '' && $(win_hash).length > 0 && !$('body').is('.template-collection, #regions') ) {
            var positionOffset = 0;

            if ( $('.nav-reviews-wrapper').length > 0 ) {
                positionOffset = $('.nav-main').height() - $('.nav-reviews-wrapper').height();
            } else {
                positionOffset = $('.nav-main').height();
            }

            try {
                var scrollPositionOffset = '';
                var scrollRelocate = setInterval(function(){
                    scrollPositionOffset = Math.round($(win_hash).offset()?.top - positionOffset);
                    if ( window.pageYOffset !== scrollPositionOffset ) { $('html, body').scrollTop(scrollPositionOffset); } else { clearInterval(scrollRelocate); }
                }, 200);
                setTimeout(function() { clearInterval(scrollRelocate); }, 2000);
            } catch(e) {}
        }
    }

    // REDIRECT-TOP BUTTON
    if ( $(document).height() > $(window).height()*3 ) {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent) || /iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('.redirect-top').addClass('mobile');
        }

        $('.redirect-top').click(function(){
            $('html, body').animate({scrollTop: 0}, 500);
        });
        var showTopReturnDelay;
        function showTopReturn() {
            if ($(window).scrollTop() > $(window).height()*1.5 && !$('.redirect-top').hasClass('visible')) {
                window.clearTimeout(showTopReturnDelay);
                $('.redirect-top').css('display','flex');
                setTimeout(function() { $('.redirect-top').addClass('visible'); },50 );
            } else if ( $(window).scrollTop() <= $(window).height()*1.5 && $('.redirect-top').hasClass('visible') ) {
                $('.redirect-top').removeClass('visible');
                showTopReturnDelay = setTimeout(function(){ $('.redirect-top').hide(); },250);
            }
        } showTopReturn();
        $(document).scroll(function () { showTopReturn(); });
    }

    function drawerFadeout(e) {
        target = e.target || e;

        if ( target.scrollTop + target.offsetHeight < target.scrollHeight - 15 ) {
            $(target).find('.fadeout').css('height', '100px');
        } else {
            $(target).find('.fadeout').css('height', 0);
        }
    }

    window.drawer = [];
    $.drawer = function() {}
    $.drawer.build = function(e) {
        if ( $(e).find('.drawer-navigation').length === -1 ) { $(e).prepend('<div class="row drawer-navigation"><div class="col-12 d-flex"><div class="drawer-close">Close</div></div></div>'); }
        if ( $(e).find('.drawer-body').length === -1 ) { $(e).children().not('.drawer-navigation').wrapAll('<div class="drawer-body"></div>'); }
        $(e).addClass('drawer-built');
    }
    $.drawer.open = function(e) {
        // Measure and create scrollbar placeholder, disable scroll
        var widthScrollbar = null;
        if ($("body").height() > $(window).height()) {
            var outer = document.createElement("div");
            outer.className = 'modal-scrollbar-measure', document.body.appendChild(outer);
            widthScrollbar = outer.getBoundingClientRect().width - outer.clientWidth;
            document.body.removeChild(outer);
            $('body').addClass('drawer-open').css('padding-right',widthScrollbar).css('display','block');
            $('.absolute-top, .fixed-top').css('padding-right',15+widthScrollbar);
            $('#fc_frame').css('margin-right',widthScrollbar);
        }

        //$(e).css('display','');
        var target = '[drawer-content="'+ (($(e).attr('drawer-open') !== undefined) ? $(e).attr('drawer-open') : $(e).attr('drawer-link')) + '"]';
        if ( !$(target).hasClass('drawer-built') ) { $.drawer.build(target); }
        $(target).wrap('<div class="drawer" data-frame="0"><div class="drawer-content"></div></div>').parents('.drawer').fadeIn(250, function() { $(this).addClass('show') });
        $('<div class="drawer-backdrop"></div>').hide().appendTo('body').fadeIn();

        var targetBody = $(target).find('.drawer-body');
        if ( $(targetBody).find('.fadeout').length != 0 ) {
            drawerFadeout(targetBody[0]);
            targetBody[0].addEventListener('scroll', drawerFadeout);
        }
    }
    $.drawer.close = function(e) {
        target = $(e).hasClass('drawer') ? $(e) : $(e).parents('.drawer');

        targetBody = $(target).find('.drawer-body');
        if ( $(targetBody).find('.fadeout').length != 0 ) {
            targetBody[0].removeEventListener('scroll', drawerFadeout, false);
        }

        $('.drawer-backdrop').fadeOut(250, function(){ $(this).remove() });
        target.removeClass('show').fadeOut(250, function() {
            target.children('.drawer-content').children().unwrap().unwrap();

            // Remove scrollbar placeholder
            $('body').removeClass('drawer-open').css('padding-right','').css('display','');
            $('.absolute-top, .fixed-top').css('padding-right','');
            $('#fc_frame').css('margin-right','');
        });
        $(window).trigger('drawer', ['close', e]);
    }
    $.drawer.navigate = function(e,d) {
        var navDirection, target;
        if (d == null) {
            navDirection = $(e).hasClass('prev') ? -1 : 1;
            target = '[drawer-content="'+ $(e).attr('drawer-link') + '"]';
        } else {
            navDirection = d.indexOf('prev') !== -1 ? -1 : 1;
            target = $(e);
        }

        // Construct drawer frame offscreen
        if ( !$(target).hasClass('drawer-built') ) { $.drawer.build(target); }
        $(target).wrap('<div class="drawer show" data-frame="'+ navDirection +'"><div class="drawer-content"></div></div>').parents('.drawer').show();

        // Animate drawer frame change
        setTimeout(function() {
            $('.drawer').each(function() {
                var _this = this,
                    newFrame = parseInt($(_this).attr('data-frame')) + (navDirection*-1);
                $(_this).attr('data-frame', newFrame);

                // Deconstruct non-visible drawer frames
                if ( newFrame != 0 ) {
                    setTimeout(function() {
                        $(_this).children('.drawer-content').children().unwrap().unwrap();
                    }, 500);
                }
            });
        }, 100);
    }
    // INIT GENERIC DRAWER CLICK EVENTS
    $(document).on('click', '[drawer-open]', function(e) { $.drawer.open(this); })
                .on('click', '.drawer', function(e) { if (e.target !== this) return; $.drawer.close(this); })
                .on('click', '[drawer-link="close"]', function(e) { $.drawer.close(this); })
                .on('click', '[drawer-link].prev, [drawer-link].next', function(e) { $.drawer.navigate(this) });
    $(window).resize(function() {
        if ( $(window).width() >= 992 && $('.drawer.show').length > 0 ){ $.drawer.close($('.drawer')); }
    })

    // INITIATE BOOTSTRAP TOOLTIP
    whenAvailable('bootstrap', function() {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')),
              popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));

        tooltipTriggerList.map(function (tooltipTriggerEl) {  return new bootstrap.Tooltip(tooltipTriggerEl) });
        popoverTriggerList.map(function (popoverTriggerEl) { return new bootstrap.Popover(popoverTriggerEl) });
    });

    // INITIATE AOS IF REQUIRED
    if ( $('[data-aos]').length > 0 ) {
        $('head').append('<link href="https://unpkg.com/aos@2.3.4/dist/aos.css" rel="stylesheet"></link><script src="https://unpkg.com/aos@2.3.4/dist/aos.js"></script>');
        whenAvailable('AOS', function() {
            AOS.init();
        });
    }

    // INITIATE NOTIFY V2 IF REQUIRED
    if ( $('.notify-v2, [data-notify-popup]').length > 0 ) {
        $('body').append('<script src="' + asset_url('notify-v2.js') + '" defer></script>');
    }

    $('body').on('click', '.popup-youtube, .popup-fbpremiere', function(e) {
        e.preventDefault();

        var url = new URL($(this).attr('href')),
            video_id = url.searchParams.get('v'),
            video_t = url.searchParams.get('t')?.replace('s', '') || '0',
            video_end = url.searchParams.get('end')?.replace('s', '') || '0',
            modalVideoShort = '',
            video_padding = 'padding-bottom: 52.25%'
            embed_url = '';
        // let's try for shorts
        if (!video_id) {
            let pathname = url.pathname.split('/');
            if(pathname[1] === 'shorts') {
                video_padding = 'padding-bottom: 173%';
                modalVideoShort = 'modal-video-shorts'
                video_id = pathname[2];
            }
        }
        if ( $(this).hasClass('popup-youtube') ){
            embed_url = 'https://www.youtube.com/embed/' + video_id + '?autoplay=1&amp;start=' + video_t + '&end=' + video_end + '&amp;modestbranding=1&amp;rel=0';
        } else {
            embed_url = 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ffacebook%2Fvideos%2F' + video_id + '%2F&width=1920&show_text=false&height=1080&appId&autoplay=true';
        }

        $('body').append('<div class="modal fade" id="modal_video" tabindex="-1" aria-labelledby="Video Popup" aria-hidden="true"><div class="modal-dialog modal-xl modal-video '+modalVideoShort+' modal-dialog-centered"><div class="modal-content rounded-0 border-0 bg-transparent"><div class="text-end p-1"><button type="button" class="btn-close bg-white mt-n4" data-bs-dismiss="modal" aria-label="Close"></button></div>'+
        '<div style="' + video_padding + '"><iframe class="embed-responsive-item position-absolute w-100 h-100 border-0" src="' + embed_url + '" allowscriptaccess="always" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe></div>' + ($(this).hasClass('popup-fbpremiere') && $('.popup-video-contents').length > 0 ? $('.popup-video-contents').html() : '') + '</div></div></div>')
        $('#modal_video')?.modal('show');
    }).on('hide.bs.modal', '#modal_video', function (e) { setTimeout(function() { $('#modal_video')?.remove(); }, 250); })

    // INITIATE PHOTOSWIPE IF REQUIRED
    if ( $('.popup-gallery, .popup-image, [data-popup-modal]').length > 0 ) {
        $('body').append('<link href="' + asset_url('photoswipe.min.css') + '" rel="stylesheet"></link><script src="' + asset_url('photoswipe-bundle.min.js') + '"></script>');
        whenAvailable('PhotoSwipe', function(){

            var gallery = null;

            $('body').on('click', '.popup-image', function(e){
                e.preventDefault();

                if (document.querySelectorAll('.pswp').length == 0) {
                    $('body').append('<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>');
                }

                var pswpElement = document.querySelectorAll('.pswp')[0],
                    items = [],
                    index = 0,
                    _this = this;

                if ( $(this).parents('.popup-gallery').length > 0 ) {
                    gallery = $(this).parents('.popup-gallery')[0];
                    $(gallery).find('.popup-image' + ($(e.currentTarget).hasClass('active') ? '.active' : '')).each(function(i, v) {
                        if( $(v).is($(_this)) ) { index = i; }
                        if ($(v).data("popuptype") == "video") {
                            items.push({ html: $(v).data("video-src") });
                        } else {
                            var imgTitle = "";
                            if( $(v).data("title")){
                                imgTitle =  $(v).data("title")
                            }
                            items.push({ src: v.href, w: 0, h: 0 , title: imgTitle});
                        }
                    });
                } else {
                    items.push({ src: this.href, w: 0, h: 0 });
                }

                var options = {
                    index: index,
                    loop: false,
                    history: false,
                    bgOpacity: .9,
                    timeToIdle: 0,
                    timeToIdleOutside: 0,
                    preloaderEl: true,
                    shareEl: false,
                };


                gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
                gallery.listen('gettingData', function(index, item) {
                    if (item.initResponsive !== true && item.src) {
                        if (item.w < 1 || item.h < 1) {
                            var img = new Image(),
                                realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

                            img.onload = function() {
                                item.src = this.src;
                                item.w = this.width;
                                item.h = this.height;
                                gallery.invalidateCurrItems();
                                gallery.updateSize(true);
                            }

                            if( realViewportWidth <= 1200 ) {
                                // Load image for smaller screens
                                if ( item.src.indexOf('cdn.shopify.com') > 0 ) {
                                    item.src = item.src.replace('.jpg', '_1200x.jpg').replace('.png', '_1200x.png');
                                } else {
                                    // Imagekit resize filter
                                    // Should exclude product display gallery
                                    if (!item.src.includes('tr:n-display_gallery')) {
                                        item.src = item.src.replace('subimage', 'subimage/tr:n-w_1200');
                                    }
                                }
                            } else {
                                // Load original image
                                item.src = item.src;
                            }

                            item.initResponsive = true;
                            img.src = item.src;
                        }
                    }
                });
                gallery.init();
            });


            // Handle mobile on click outside space to close
            document.addEventListener("click", function(e){
                if(e.target && e.target.classList.contains('pswp__item') && gallery)
                    gallery.close();
            });
        });
    }

    // INITIATE MAGNIFIC-POPUP IF REQUIRED
    if ( $('.magnific-popup, .image-popup, .gallery-popup').length > 0 ) {
        $('body').append('<link href="' + asset_url('magnific-popup.css') + '" rel="stylesheet"></link><script src="' + asset_url('jquery.magnific-popup.min.js') + '"></script>');
        whenAvailable('magnificPopup', function(){
            $('.image-popup').magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                image: {
                    verticalFit: true
                }
            });
            $('.gallery-popup').each(function(i, v) {
                $(v).magnificPopup({
                    delegate:"a.magnify",
                    type:"image",
                    closeOnContentClick:!1,
                    closeBtnInside:!1,
                    mainClass:"mfp-with-zoom mfp-img-mobile",
                    image:{verticalFit:!0,titleSrc:function(e){return e.el.attr("title")}},
                    gallery:{enabled:!0},
                    zoom:{
                        enabled:!0,
                        duration:300,
                        opener:function(e){return e.find("img")}
                    }
                });
            });
        });
    }

    // AJAX POPUP MODAL
    const popup_modal_template = document.createElement('template'),
          $POPUP_STRUCTURE = `<div class="modal fade ajax-modal" data-popup-source="<!-- source -->" tabindex="-1" role="dialog" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                        <div class="modal-content overflow-hidden">
                                            <div class="modal-overlay absolute d-flex justify-content-center align-items-center active">
                                                <div class="collection-sidebar-spinner">
                                                    <div class="spinner-border text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>`;

    whenElementAvailable('[data-popup-modal]', () => {
      document.querySelectorAll('[data-popup-modal]').forEach(popup_modal_link => {
          popup_modal_link.addEventListener('click', event => {
              event.stopPropagation()
              let popup_modal_url = popup_modal_link.getAttribute('data-url'),
                  popup_modal_script_type = popup_modal_link.getAttribute('data-script-type'),
                  popup_modal_script = popup_modal_link.getAttribute('data-script'),
                  popup_modal_css = popup_modal_link.getAttribute('data-css'),
                  popup_modal_code = popup_modal_template,
                  popup_modal_element = document.querySelector('[data-popup-source="' + popup_modal_url + '"]');

              // Create modal if non-existent
              if ( popup_modal_element == null ) {
                  popup_modal_code.innerHTML = $POPUP_STRUCTURE.replace('<!-- source -->', popup_modal_url);
                  popup_modal_code = popup_modal_code.content.firstChild;

                  document.body.append(popup_modal_code);
                  popup_modal_element = document.querySelector('[data-popup-source="' + popup_modal_url + '"]')
              }

              whenAvailable('bootstrap', function() {
                  // Get and show modal
                  let popup_modal = bootstrap.Modal.getOrCreateInstance(popup_modal_element),
                      popup_modal_content = popup_modal_element.querySelector('.modal-content');
                      popup_modal_overlay = popup_modal_element.querySelector('.modal-overlay');
                  popup_modal.show();

                  // If modal popup contents not initialized
                  if ( !popup_modal_element.classList.contains('modal-initialized') ) {
                      // Fetch and populate modal popup
                      fetch(popup_modal_url)
                          .then(function(response) {
                              // When the page is loaded convert it to text
                              return response.text()
                          })
                          .then(function(html) {
                              // Initialize the DOM parser
                              let parser = new DOMParser(),
                                  doc = parser.parseFromString(html, "text/html");

                              // Print additional script if necessary
                              if ( popup_modal_script != null ) {
                                  if ( !document.querySelector('script[src="' + popup_modal_script + '"]')) {
                                      let script = document.createElement('script');
                                      script.type = popup_modal_script_type != null ? popup_modal_script_type : 'text/javascript';
                                      script.src = popup_modal_script;

                                      document.body.append(script);
                                  }
                              }
                              if ( popup_modal_css != null ) {
                                  if ( !document.querySelector('link[href="' + popup_modal_css + '"]')) {
                                      let css = document.createElement('link');
                                      css.rel = 'stylesheet';
                                      css.href = popup_modal_css;

                                      document.body.append(css);
                                  }
                              }

                              popup_modal_content.append(doc.querySelector('#modalContent'));
                              popup_modal_element.classList.add('modal-initialized');
                              popup_modal_overlay.classList.remove('active');

                              whenAvailable('lazyload', function() { initLazyload(); });
                          })
                          .catch(function(err) {
                              console.log('Failed to fetch page: ', err);
                          });
                  }

              });
          });
      });
    });

    whenAvailable("getCookie", function() {
    // Geotargeted Content
    let geo_region = getCookie('_geo_loc_region'),
        content_geo_specific = document.querySelectorAll('[data-geo-specific-content]');

    content_geo_specific.forEach(element => {
        let content_by_region = {
            show: element.getAttribute('data-region-show') || '',
            hide: element.getAttribute('data-region-hide') || ''
        }

        if (
            ( content_by_region.show != '' && geo_region != '' && content_by_region.show.indexOf(geo_region) != -1 ) || // Default hidden content, that are shown by geotargeting
            ( content_by_region.hide != '' && (geo_region == '' || content_by_region.hide.indexOf(geo_region) == -1) ) // Default shown content, that are hidden by geotargeting
        ) {
            element.classList.remove('d-none');
        }
    });
    });


    // FINANCING MODAL
    $('body').on('click', '[data-financing-modal]', function(e) {
        e.preventDefault();
        if (!$('#financingModal').length) {
            var html = `<div class="modal fade ajax-modal" id="financingModal" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content overflow-hidden">
                                    <div id="financingModalOverlay" class="modal-overlay absolute d-flex justify-content-center align-items-center active">
                                        <div class="collection-sidebar-spinner">
                                            <div class="spinner-border text-primary" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

            $('main').append(html);
            $('[data-split-4]').attr('data-split-4', $('[data-instalment-split="4"]').first().text());
            $('[data-split-3]').attr('data-split-3', $('[data-instalment-split="3"]').first().text());
            $('[data-split-6]').attr('data-split-6', $('[data-instalment-split="6"]').first().text());
            $('#financingModal').modal('show');

            $.ajax({
                dataType: "html",
                url: locale_root + '/?view=financing-modal',
            }).then(function(data) {
                var content = $(data).filter('#ajaxFinancingModal');
                $('#financingModalOverlay').removeClass('active');
                $('#financingModal .modal-content').append(content.html());
                $('#financingModal [data-instalment-split="4"]').text($('[data-split-4]').attr('data-split-4'));
                $('#financingModal [data-instalment-split="3"]').text($('[data-split-3]').attr('data-split-3'));
                $('#financingModal [data-instalment-split="6"]').text($('[data-split-6]').attr('data-split-6'));
            });
        } else {
            $('#financingModal').modal('show');

            // update instalment value when there's change in total value
            $('#financingModal [data-instalment-split="4"]').empty().html($('[data-instalment-split="4"]').first().text());
            $('#financingModal [data-instalment-split="3"]').empty().html($('[data-instalment-split="3"]').first().text());
            $('#financingModal [data-instalment-split="6"]').empty().html($('[data-instalment-split="6"]').first().text());
        }
    });

    // PROMOTIONS DRAWER / DROPDOWN
    if ( $('.promotion-wrapper').length > 0 ) {
        var mobile_breakpoint = 992,
            document_width = $(document).width(),
            sizeMobile = (document_width < mobile_breakpoint) ? true : false;

        $('.promotion-wrapper').on('click', '.promotion-special, .promo-main', function() {
            if (sizeMobile) {
                _this = this;
                whenAvailable('drawer', function() {
                    $.drawer.open(_this);
                });
            } else {
                $('.promo-dropdown').toggle();
            }
        }).on('mouseleave',function() {
            if (!sizeMobile) {
                $('.promo-dropdown').fadeOut(function() { $(this).attr('style','') });
            }
        });
    }

    // SHARE LINK
    if ( $('#share_link').length > 0 ) {
        $('#share_link').click(function(){
            $('#share_link_textarea').select();
            document.execCommand('copy');
            var _this = $(this);
            _this.tooltip('show');
            setTimeout(function(){ _this.tooltip('hide'); }, 1200);
        });
    }

    // PARALLAX FUNCTION (widely used in partners pages)
    if ( $('.parallax-obj, .parallax-bg, .parallax-init').length > 0 ) {
        function parallaxElm() {
            const posScroll = $(window).scrollTop();

            $('.parallax-obj').each(function() {
                var topOffset = Math.max($(window).height(), $(this).offset().top) - $(window).height();
                if ( posScroll >= topOffset ) {
                    var marginOffset = (Math.max(0, posScroll - topOffset) * $(this).attr('data-modifier')).toFixed(2);
                    $(this).css({'transform' : 'translateY('+ marginOffset +'px)'});
                    $(this).css({'-webkit-transform' : 'translateY('+ marginOffset +'px)'});
                }
            });

            // to be used for splash only
            $('.parallax-bg').each(function() {
                $(this).css({'background-position':'50% '+($(this).attr('data-modifier') * posScroll).toFixed(2)+'px'});
            });
        }

        //if (!isMobile && $(window).width() > 991) {
            $(window).scroll(function(){ parallaxElm(); });
            parallaxElm();
        //}
    }

    // to resolve Safari issue on infinite scroll by triggering the scrolling after loading
    if ( $('.infinite-slider').length > 0 ) {
        setTimeout(function() {
            $('.infinite-slider ul').addClass('infinite-play');
        }, 1000);
    }

    // remove emojis in all fields (input, textarea)
    $("input, textarea").not(".allowemoji, [type='file']").bind('keyup input change', function(event) {
        var text = $(this).val();
        var noEmoji = removeEmojis(text);
        $(this).val(noEmoji);
    });

    // INITIATE GOOGLE RECAPTCHA WHEN IT EXISTS
    if ( $('.g-recaptcha').length > 0 ) {
        $('body').append('<script src="https://www.google.com/recaptcha/api.js" async defer></script>');
    }
});
});

// Add thousand comma break
function formatPrice(num) {
    value = parseInt(num).toFixed(2).replace('.00', '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return value;
}

function removeEmojis (text) {
    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return text.replace(regex, '');
}

function validateKRCheckbox(main_wrapper = '') {
    let checkboxChecked = true;

    $(main_wrapper).find('.input-checkbox[required]').each(function(){
        let $checkboxWrapper = $(this).parent('.checkbox__input');

        if (!$(this).is(':checked')) {
            $checkboxWrapper.addClass('is-invalid');
            $checkboxWrapper.siblings('.checkbox__label').addClass('is-invalid');
            checkboxChecked = false;
        } else {
            $checkboxWrapper.removeClass('is-invalid');
            $checkboxWrapper.siblings('.checkbox__label').removeClass('is-invalid');
        }
    });

    if (checkboxChecked) {
        $(main_wrapper).find('.invalid-feedback').hide();
    } else {
        $(main_wrapper).find('.invalid-feedback').show();
    }
}

function sentryLogger(message, exception = null, extra = {}, level = 'error') {
    if ( typeof Sentry != 'undefined' ) {
        Sentry.captureException(new Error(message), (scope) => {
            scope.setContext("extra", extra);
            scope.setLevel(level);
            if(typeof allCartItems != 'undefined') {
                scope.setContext("allCartItems", allCartItems);
            }
            if(exception) {
                scope.setContext("exception", JSON.stringify(exception));
            }
            return scope;
        });
    }
}
whenAvailable('$', function() {

    $.validateForm = function(form_id = '') {
        $(form_id).addClass('was-validated');
        if ($(form_id + '.was-validated .form-control:invalid').first().length > 0) { $('html,body').animate({scrollTop: $(form_id + '.was-validated .form-control:invalid').first().offset().top - ($('.nav-main').height() + 30)},'slow');}
        if ($('.terms-kr').length > 0) { validateKRCheckbox('.terms-kr'); }
        if ($('#form_agree_terms').length > 0) { $('#form_agree_terms').prop('checked', true); }
    }

    $.submitForm = function(url = '', data = {}, $form) {
        let $responseModal = $('#response_modal'),
            $recaptchaFeedback = $('.g-recaptcha + .invalid-feedback');

        if (grecaptcha.getResponse().length == 0) {
            if ($recaptchaFeedback.length > 0) {
                $recaptchaFeedback.show();
            } else {
                alert('Please click the reCAPTCHA checkbox.');
            }
            return false;
        }

        $form.find('input, textarea').prop('readonly', true);
        $form.find('button[type=submit]').prop('disabled', true);
        $('#submit_spinner').removeClass('d-none');
        $responseModal.modal('hide');
        $recaptchaFeedback.hide();

        $.ajax({
            url: url,
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            cache: false
        }).done(function (data) {
            $form.removeClass('was-validated');
            $form.find('input:not([type="hidden"]):not([type="radio"]), select:not(.language-selector), textarea').val('').prop('checked', false).removeClass('is-invalid'); // Empty/Reset all fields except hidden and radio buttons
            if ($('#shopify_order_name').length > 0) { $('#shopify_order_name').prop('disabled', true).attr('placeholder', ''); } // for QUICCS and Rust
            $responseModal.modal('show').addClass('success');
        }).fail(function (xhr, status, error) {
            $responseModal.modal('show').addClass('error');
            console.log(xhr);
            if ( typeof Sentry != 'undefined' ) {
                Sentry.captureException(new Error('[SLE] Error occurred on form [' + $form.attr('id') + ']'));
            }
        }).then(function(){
            $form.find('input, textarea').prop('readonly', false);
            $form.find('button[type=submit]').prop('disabled', false);
            $('#submit_spinner').addClass('d-none');
            grecaptcha.reset(); // reset recaptcha
        });
    }

    $(function() {
        //eligibleCountriesForFreeTrial and eligibleStoreCodeBaseOnCountries are a pair, need to match both
        whenAvailable("getCookie", function() {

        const eligibleCountriesForFreeTrial = ['NL', 'PL'];
        const eligibleStoreCodeBaseOnCountries = ['XX'];
        const eligibleStoreCode = ['XX'];

        const currentCountry = getCookie('_geo_country_code')
        const store_code = $('body').data('store-code');
        const windowWidth = $(window).width();

        //collection filter remove mobile if on desktop size
        if (windowWidth >= 768) {
            $('.free-trial-filter-mb').remove();
        }

        //collection filter remove desktop if on mobile size
        if (windowWidth < 768) {
            $('.free-trial-filter-desktop').remove();
        }

        if((eligibleCountriesForFreeTrial.includes(currentCountry) && eligibleStoreCodeBaseOnCountries.includes(store_code)) || eligibleStoreCode.includes(store_code)){
            $('.free-trial-dropdown').show();
            $('.free-trial-info-wrapper').show();
            $('.free-return-text').show();
            $('.free-return-filter').addClass('show');

            $('.sale-nav-mobile-eligible-trial').show();
            $('.sale-nav-mobile-eligible-trial').show();
            $('.sale-nav-mobile').hide();

            $('.product-sale-banner-evo-lite-wrapper').show();

            // nav bar
            $('.free-trial-nav-bar').show();
            $('.index.sale-nav-bar').show();

            $('.free-trial-homepage-nav-bar').addClass('show');
            $('.sale-homepage-nav-bar').removeClass('show');

            // collection feature
            $('.free-trial-collection-feature').addClass('show');
            $('.default-collection-feature').removeClass('show');

            const btnOfferNav = document.querySelector('.btn-offer-nav');
            if(btnOfferNav) {
                btnOfferNav.setAttribute('href', '/collections/gaming-chairs?availability=freereturn');
            }

            $('.free-trial-filter-mb').addClass('show');

            const url = new URL(window.location.href);
            const has_search_params = Array.from(url.searchParams.keys()).length > 0;

            if (has_search_params && url.searchParams.get('availability') === 'freereturn') {
                $("#freereturn").prop("checked", true);
            }

        } else {
            $('.free-trial-filter-mb').removeClass('show');

            $('.default-collection-feature').addClass('show');
            $('.free-trial-collection-feature').removeClass('show');

            $('.product-sale-banner-wrapper').show();

            //nav bar
            $('.free-trial-nav-bar').hide();
            $('.sale-nav-bar').show();

            $('.free-trial-homepage-nav-bar').removeClass('show');
            $('.sale-homepage-nav-bar').addClass('show');

            // collection feature
            $('.default-collection-feature').show();
        }

        });

    });



    //stickness in titan evo feature page
    $(function() {
        function stickyOnTitanEvoFeature() {
            const windowWidth = $(window).width();

            if (windowWidth >= 1280) { 
                $("#nano-gen-feature").addClass("sticky-element-feature");
            } else {
                $("#nano-gen-feature").removeClass("sticky-element-feature");
            }
        }

        stickyOnTitanEvoFeature();
        whenAvailable('$', function() {
            $(window).on( "resize", function() {
                stickyOnTitanEvoFeature();
            });
        })
    });

}); 
 
/**
 * Sets up browser back button handling for Bootstrap modals
 * @param {string} modalId - ID of the modal element (without the # prefix)
 */
function setupModalBackButtonHandler(modalId) {
    const modalElement = document.getElementById(modalId);
    if (!modalElement) {
        console.error(`Modal element with ID '${modalId}' not found`);
        return;
    }

    // When modal is shown
    modalElement.addEventListener('shown.bs.modal', function() {
        window.history.pushState({ modalOpen: modalId }, '');
    });
    
    // When modal is hidden normally
    modalElement.addEventListener('hidden.bs.modal', function() {
        if (window.history.state?.modalOpen === modalId) {
            window.history.replaceState(null, '');
        }
    });
}

/**
 * Sets up global back button handler for all modals
 * This should be called once, after all modals are registered
 */
function setupGlobalBackButtonHandler() {
    // Only add the global handler once
    if (window._globalBackButtonHandlerAdded) return;
    
    window.addEventListener('popstate', function(event) {
        // Find any open modals
        const openModals = document.querySelectorAll('.modal.show');
        if (openModals.length > 0 || document.body.classList.contains('modal-open')) {
            // Force removal of modal-backdrop if it exists
            const backdrops = document.getElementsByClassName('modal-backdrop');
            while(backdrops.length > 0) {
                backdrops[0].remove();
            }
            
            // Close all open modals
            openModals.forEach(modal => {
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) modalInstance.hide();
                
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
                modal.classList.remove('show');
            });
            
            // Critical: Restore scrolling functionality
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            
            // Additional Bootstrap 5 cleanup
            document.body.removeAttribute('data-bs-overflow');
            document.body.removeAttribute('data-bs-padding-right');
        }
    });
    
    window._globalBackButtonHandlerAdded = true;
}

// Alternative: automatically register all modals
document.addEventListener('DOMContentLoaded', function() {    
    document.querySelectorAll('.modal').forEach(modal => {
        if (modal.id) setupModalBackButtonHandler(modal.id);
    });
    whenAvailable('$', function() {
        const windowWidth = $(window).width();
        if (windowWidth < 768) { 
            // Set up the global handler AFTER registering all modals
            setupGlobalBackButtonHandler();
        }
    });
});
